module.exports = __webpack_public_path__ + "static/img/error-image.ad1bebf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/error-image.png
// module id = 55
// module chunks = 1